import { render, staticRenderFns } from "./InventoryRecommendations.vue?vue&type=template&id=e74176f0"
import script from "./InventoryRecommendations.vue?vue&type=script&lang=js"
export * from "./InventoryRecommendations.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports